import styled from 'styled-components'
import { creationSubTabs } from '../../constants'

const SubTabContainer = styled.div`
  background-color: rgba(255, 255, 255, 1);
  padding: 16px;
  display: flex;
  gap: 16px;
  @media(max-width: 600px){
    padding: 32px 16px 16px;
  }
`

const Tab = styled.div`
  cursor: pointer;
  border-radius: 50%;
  border-radius: 200px;
  border: 1.2px solid #01b3ff;
  background: ${({ selected }) => (!selected ? '#FFF' : '#01B3FF')};
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  svg {
    width: 16px;
    height: 16px;
  }
`

const TabText = styled.p`
  color: ${({ selected }) => (selected ? '#FFF' : '#019AFF')};
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
`

const SubTabs = ({
  tabsArray = creationSubTabs,
  selectedIndex = 0,
  handleTabClick,
}) => (
  <SubTabContainer>
    {tabsArray?.map((tab, index) => {
      const { name, Icon } = tab
      const isTabSelected = selectedIndex === index
      return (
        <Tab
          key={name}
          selected={isTabSelected}
          onClick={() => handleTabClick(index)}
        >
          <Icon fill={isTabSelected ? '#FFF' : '#019AFF'} />
          <TabText selected={isTabSelected}>{name}</TabText>
        </Tab>
      )
    })}
  </SubTabContainer>
)

export default SubTabs
